<header>
	<h1 class="sr-only">Schiffsregister</h1>
	@if (isReady | async) {
		<schir-int-client-navbar [apiRoot]="apiRoot | async" [currentUser]="currentUser | async"/>
	}
</header>

@if (isReady | async) {
	<main class="l-container">
		<router-outlet/>
</main>
}

@if (isError | async) {
	<schir-int-client-error-page class="l-container"/>
}
